import { render, staticRenderFns } from "./vLogout.vue?vue&type=template&id=01b69659&scoped=true"
import script from "./vLogout.vue?vue&type=script&lang=js"
export * from "./vLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b69659",
  null
  
)

export default component.exports